import React, { useMemo } from 'react';
import iziToast from 'izitoast';
// import { getFileInfo } from 'src/utils';
// import { AiAgentActions, AiAgentContext } from '../pages/AgentDetailPageComponent';
import { pathImage } from './common';
import { useTranslate } from 'sbx-crm-menu-ui';
import { Upload } from 'lucide-react';
import { EnumSkillRetrieverFields } from 'src/types/Common';

interface Props {
    fileTypes: string[];
    files: File[];
    filesComponent: FileProps[];
    setFilesComponent: (files: FileProps[]) => void;
    setFiles: (files: File[]) => void;
    onchange?: (field: EnumSkillRetrieverFields) => void;
}

export interface FileProps {
    key?: string;
    name: string;
    size: number;
    url?: string;
    type: string;
}
const pdfIcon = `${pathImage}/pdfIcon.png`;
const audioIcon = `${pathImage}/audioIcon.png`;
const wordIcon = `${pathImage}/docxIcon.png`;
const excelIcon = `${pathImage}/xlsxIcon.png`;
const csvIcon = `${pathImage}/csvIcon.png`;
const txtIcon = `${pathImage}/txtIcon.png`;
const videoIcon = `${pathImage}/videoIcon.png`;


export const imageFileComponent = (file: FileProps) => {
    if(file.type === 'image') {
        return (<img src={file.url} alt={file.url} width={50} height={50} className="object-cover rounded-full" />)
    } else if(file.type.includes('pdf')) {
        return (<img src={pdfIcon} alt={'pdf'} width={50} className="object-cover" />)
    } else if(file.type.includes('audio')) {
        return (<img src={audioIcon} alt={'audio'} width={50} className="object-cover" />)
    } else if(file.type.includes('wordprocess')) {
        return (<img src={wordIcon} alt={'word'} width={50} className="object-cover" />)
    } else if(file.type.includes('spreadsheet')) {
        return (<img src={excelIcon} alt={'excel'} width={50} className="object-cover" />)
    } else if(file.type.includes('csv')) {
        return (<img src={csvIcon} alt={'csv'} width={50} className="object-cover" />)
    } else if(file.type.includes('text')) {
        return (<img src={txtIcon} alt={'text'} width={50} className="object-cover" />)
    } else if(file.type.includes('video')) {
        return (<img src={videoIcon} alt={'video'} width={50} className="object-cover" />)
    }
}

export const DragAndDropV2 = ({ fileTypes, setFilesComponent, setFiles, filesComponent, files,onchange }: Props) => {
    const [isDragging, setIsDragging] = React.useState(false);
    const inputFileRef = React.useRef<HTMLInputElement>(null);
    const { t: common } = useTranslate('common');
    const accept = useMemo(() => {
        const accept2 = fileTypes.reduce((acc, val) => {
            val = val.toLowerCase();
            if(val.includes('image')) {
                acc += 'image/*,';
            } else if(val.includes('pdf')) {
                acc += '.pdf,';
            } else if(val.includes('audio')) {
                acc += 'audio/mpeg,';
            } else if(val.includes('docx')) {
                acc += 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';
            } else if(val.includes('xlsx')) {
                acc += 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,';
            } else if(val.includes('csv')) {
                acc += '.csv,';
            } else if(val.includes('text')) {
                acc += 'text/plain,';
            } else if(val.includes('video')) {
                acc += 'video/mp4,';
            }

            return acc;
        }, "");

        return accept2.substring(0, accept2.length - 1);
    }, [fileTypes]);

    const types = useMemo(() => {
        return fileTypes.reduce((acc: string[], val) => {
            val = val.toLowerCase();
            if(val.includes('pdf')) {
                acc.push('pdf');
            } else if(val.includes('docx')) {
                acc.push('wordprocess');
            } else if(val.includes('audio')) {
                acc.push('mpeg');
            } else if(val.includes('xlsx')) {
                acc.push('spreadsheet');
            } else if(val.includes('csv')) {
                acc.push('csv');
            } else if(val.includes('text')) {
                acc.push('text');
            } else if(val.includes('video')) {
                acc.push('mp4');
            }

            return acc;
        }, []);
    }, [fileTypes]);  

    const onFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
         
        if (e.target.files?.length) {
            const filesItems: File[] = [];
            const filesPreview: FileProps[] = [];
            const fileList = e.target.files;

            for (let i = 0; i < fileList.length; i++) {
                if(fileList[i].type.includes('image')) {
                    filesItems.push(fileList[i]);
                    filesPreview.push({
                        name: fileList[i].name,
                        size: fileList[i].size,
                        url: URL.createObjectURL(fileList[i]),
                        type: 'image',
                        // type2: FileType.FILE
                    });
                } else {
                    filesItems.push(fileList[i]);
                    filesPreview.push({
                        name: fileList[i].name,
                        size: fileList[i].size,
                        type: fileList[i].type,
                        // type2: FileType.FILE
                    });
                }
            }

            // setFilesComponent( (prevFiles) => [...prevFiles, ...filesPreview]);
            setFilesComponent([...filesComponent, ...filesPreview])
            setFiles([...files, ...filesItems])
            onchange && onchange(EnumSkillRetrieverFields.EXCEL);
            // setFiles((prevFiles) => [...prevFiles, ...files]);
        }
    }

    const selectFiles = () => {
        if (inputFileRef.current) {
            inputFileRef.current.click();
        }
    };

    const onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(true);
        e.dataTransfer.dropEffect = 'copy';
    };

    const onDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const onDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(false);
        const fileList = e.dataTransfer.files;
        const filesItems: File[] = [];
        const filesPreview: FileProps[] = [];

        for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].type.includes('image')) {
                filesItems.push(fileList[i]);
                filesPreview.push({
                    name: fileList[i].name,
                    size: fileList[i].size,
                    url: URL.createObjectURL(fileList[i]),
                    type: 'image',
                });
            } else if(
                types.some(type => fileList[i].type.includes(type))
            ) {
                filesItems.push(fileList[i]);
                filesPreview.push({
                    name: fileList[i].name,
                    size: fileList[i].size,
                    type: fileList[i].type,
                    // type2: FileType.FILE
                });
            } else {
                iziToast.warning({
                    message: "This is not a correct format file",
                    position: 'topCenter'
                });
            }
        }


        setFilesComponent([...filesComponent, ...filesPreview])
        setFiles([...files, ...filesItems])
        // setFilesComponent((prevFiles) => [...prevFiles, ...filesPreview]);
        // setFiles((prevFiles) => [...prevFiles, ...files]);
    };

    return (
        <div>
            <div
                className={`${fileTypes.some(type => ['csv', 'xlsx'].includes(type)) && files.length !== 0 ? "hidden": ""} border-2 border-dashed border-purple-300 rounded-lg p-6 sm:p-10 text-center cursor-pointer transition-all duration-300 ease-in-out hover:border-pink-400 hover:shadow-md`}
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                <Upload className="mx-auto h-12 w-12 text-purple-400 transition-colors duration-300 ease-in-out group-hover:text-pink-400" />
                {isDragging ? (
                    <p className="text-sm font-medium text-purple-700">{common("drop_here")}</p>
                ) : (
                    <p className="text-sm font-medium text-purple-700">
                        {common("drag_and_drop_action_here")} {common("or")} {" "}
                        <span className="underline cursor-pointer text-purple-900 font-semibold" role="button" onClick={selectFiles}>
                            click
                        </span>
                    </p>
                )}
            </div>

            <form
                id={'form_images'}
                onReset={() => {
                    setFiles([]);
                    setFilesComponent([]);
                }}
                className="flex justify-between py-2"
            >
                <input
                    accept={accept}
                    type="file"
                    className="w-full hidden"
                    onChange={onFiles}
                    multiple={!fileTypes.some(type => ['csv', 'xlsx'].includes(type))}
                    ref={inputFileRef}
                />

            </form>
        </div>
    );
};
